import { CommonModule, Location } from '@angular/common';
import {
  Component,
  OnInit,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import {
  MemberService,
} from 'src/app/core/services/member.service';
import { CommonService, DateMode } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import {
  PaymentDataService,
  PaymentExperiencePayload,
} from 'src/app/core/services/payment-data.service';
import {
  AppToggleButtonComponent,
  BtnToggleOptions,
} from 'src/app/shared/components/app-button-group/app-toggle-button.component';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppCheckboxComponent } from 'src/app/shared/components/app-checkbox/app-checkbox.component';
import {
  AppSelectInputComponent,
  SelectModel,
} from 'src/app/shared/components/app-select-input/app-select-input.component';
import {
  CreditCardInfoModel,
  PaymentFrequencyId,
  PaymentInfoModel,
  PaymentType,
  PaymentTypeId,
} from 'src/app/shared/models/paymentData';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import { PlanService } from 'src/app/core/services/plan.service';
import { PaymentModalComponent } from 'src/app/shared/components/payment-modal/payment-modal.component';
import { ModalService } from 'src/app/core/services/modal.service';
import {
  AppInputCustomComponent,
  InputMaskTypes,
} from 'src/app/shared/components/app-input-custom/app-input-custom.component';
import {
  AppInputComponent,
  InputType,
} from 'src/app/shared/components/app-input/app-input.component';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserModel } from 'src/app/shared/models/userModel';
import { ExperienceService } from 'src/app/core/services/experience.service';
import { ReplaceTextPipe } from 'src/app/shared/pipe/replace-text.pipe';

@Component({
  selector: 'app-finalizar-resgate',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppSelectInputComponent,
    AppCheckboxComponent,
    AppButtonComponent,
    AppToggleButtonComponent,
    CustomCurrencyPipe,
    RouterModule,
    PaymentModalComponent,
    AppInputCustomComponent,
    AppInputComponent,
  ],
  templateUrl: './finalizar-resgate.component.html',
  styleUrl: './finalizar-resgate.component.scss',
})
export class FinalizarResgateComponent implements OnInit {

  balanceUsed: number = 0;
  remainingBalance: number = 0;
  adjustedExperienceValue: number | null = null;
  memberScore: number = 0;
  useBalanceControl = new FormControl<boolean>(false);
  useBalanceOptions: BtnToggleOptions[] = [
    { label: 'Sim', value: 'true' },
    { label: 'Não', value: 'false' },
  ];
  currentPlan!: any;
  labelColor = 'white';
  screenWidth: number;

  InputTypeEnum = InputType;
  InputMaskTypesEnum = InputMaskTypes;
  DateMode = DateMode;

  logoUrl: string = localStorage.getItem('imageLogo') || '';
  pageTitle = 'Finalize o resgate';
  PaymentType = PaymentType;
  paymentType = PaymentType.CREDITO;
  paymentModalData: any;
  currentUserData: any;
  canChekPix = true;
  showCanUseCardControl = true;

  modalId = 'payment-modal';
  submitCount: number = 0;

  couponMessage = '';

  couponFormGroup = new FormGroup({
    coupon: new FormControl<any>(null)
  });
  finalizePaymentformGroup = new FormGroup({
    experienceControl: new FormControl<string>('', Validators.required),
    formOfPaymentControl: new FormControl<string>('', Validators.required),
    creditCardControl: new FormControl<string>(''),
  });
  creditCardformGroup = new FormGroup({
    cardNumberControl: new FormControl<string>(''),
    expirationDateControl: new FormControl<string>(''),
    cvvControl: new FormControl<string>(''),
    cardNameControl: new FormControl<string>(''),
    CPFControl: new FormControl<string>(''),
    numberOfInstallmentsControl: new FormControl<string>(''),
    canUseCardControl: new FormControl<boolean>(true),
  });

  creditCardInfo: WritableSignal<CreditCardInfoModel[]> = signal([]);

  creditCardOptions = computed<SelectModel[]>(() => {
    if (!this.creditCardInfo()) {
      return [];
    }

    return this.creditCardInfo().map((cardInfo) => {
      return {
        code: cardInfo.cardNumber,
        name: `${cardInfo.cardOperator} - ....${cardInfo.cardNumber.slice(-4)}`,
      } as SelectModel;
    });
  });

  paymentSummary: any;
  experiences: any[] = [];
  paymentMethodType: any;

  frequencyOptions: BtnToggleOptions[] = [];

  formOfPaymentOptions: BtnToggleOptions[] = [];

  buttonOptions = {
    buttonText: 'FINALIZAR',
    borderRadius: '25px',
    buttonBorderWidth: 'none',
    buttonBorderColor: 'none',
    buttonSize: 'btn btn-sm py-2 px-4 w-100 btn-primary',
  };

  buttonAddCardOptions = {
    buttonText: '+ Adicionar cartão',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm py-2 px-5 btn-primary',
  };

  backOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px',
  };

  couponOptions = {
    buttonText: 'Aplicar',
    buttonSize: 'btn btn-md btn-secondary mt-4 w-100',
    borderRadius: '25px',
  };

  showCreditCardOptions = false;

  private _destroy$ = new Subject<void>();

  numberOfInstallmentsOptions: SelectModel[] = [];

  protected experienceOptions = [] as SelectModel[];
  dependentsOptions = [] as SelectModel[];

  experienceItem: any;

  memberPlan: any;
  selectedExperience: any = null;
  benefitsPlanSelected: any;
  user: UserModel;
  deviceId: string;

  private memberId: string;
  isLoggedIn = false;

  operation: '';

  constructor(
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private paymentDataService: PaymentDataService,
    private router: Router,
    private memberService: MemberService,
    private planService: PlanService,
    private experienceService: ExperienceService,
    private modalService: ModalService,
    private alertService: AlertService,
    private authService: AuthService,
    private userService: UserService,
    private commonService: CommonService,
    private location: Location,
    private replaceTextPipe: ReplaceTextPipe
  ) {
    this.addScriptMercadoPago();

    this.user = this.userService.currentUserValue as UserModel;

    this.authService.isLoggedIn.subscribe((status) => {
      this.isLoggedIn = status;
    });

    this.memberId = this.memberService.getMemberId();

  }

  ngOnInit(): void {
    document.body.style.overflow = 'auto';
    this.currentUserData = this.localStorageService.getItem('current-user');

    if (!this.currentUserData) {
      console.error('Dados do usuário não encontrados no local storage.');
      return;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      const experienceId = params['experienceId'];
      const useBalance = params['useBalance'] === 'true';

      if (experienceId) {
        // Buscar a lista de experiências e selecionar a correspondente
        this.memberService.getMemberPlanDashboardData(this.currentUserData.id).subscribe({
          next: (currentPlan: any) => {
            this.currentPlan = currentPlan;

            this.experienceService.getExperiencesByPlan(this.currentPlan.plan.id).subscribe({
              next: (experiences: any[]) => {
                this.experiences = experiences;
                const selectedExperience = this.experiences.find((exp) => exp.id === experienceId);

                if (selectedExperience) {
                  this.selectedExperience = selectedExperience;
                  this.finalizePaymentformGroup.get('experienceControl')?.setValue(selectedExperience.id);

                  // Atualiza as opções de parcelas com base na experiência selecionada
                  this.updateInstallmentsOptions(selectedExperience);

                  this.useBalanceControl.setValue(useBalance);

                  this.updatePaymentOptionsAndTotal(useBalance ?? false, selectedExperience);
                } else {
                  console.warn('Experiência com o ID fornecido não encontrada.');
                }
              },
              error: (e) => {
                console.error('Erro ao buscar experiências:', e);
                this.alertService.showAlert(AlertType.WARNING, 'Erro ao buscar experiências.');
              },
            });
          },
          error: (e) => {
            console.error('Erro ao buscar o plano atual do sócio:', e);
            this.alertService.showAlert(
              AlertType.WARNING,
              this.replaceTextPipe.transform('Erro ao buscar o plano atual do sócio.')
            );
          },
        });
      }
    });

    // Buscar saldo do sócio
    this.experienceService.getMemberScore(this.currentUserData.id).subscribe({
      next: (score: any) => {
        this.memberScore = score || 0;
      },
      error: (e) => {
        console.error('Erro ao buscar saldo do sócio:', e);
        this.alertService.showAlert(
          AlertType.WARNING,
          this.replaceTextPipe.transform('Erro ao buscar saldo do sócio.')
        );
      },
    });

    // Listener para o select de experiência
    this.finalizePaymentformGroup.controls.experienceControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((selectedExperienceId) => {
        const selectedExperience = this.experiences.find((experience) => experience.id === selectedExperienceId);

        if (!selectedExperience) {
          this.useBalanceControl.disable();
          return;
        }

        this.useBalanceControl.enable();
        this.updatePaymentOptionsAndTotal(this.useBalanceControl.value ?? false, selectedExperience);
      });

    // Listener para o checkbox "Utilizar saldo"
    this.useBalanceControl.valueChanges.pipe(takeUntil(this._destroy$)).subscribe((useBalance) => {
      const selectedExperienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;
      const selectedExperience = this.experiences.find((experience) => experience.id === selectedExperienceId);

      if (!selectedExperience) {
        // Se nenhuma experiência estiver selecionada, desabilita o checkbox e os métodos de pagamento
        this.useBalanceControl.disable();
        this.finalizePaymentformGroup.controls.formOfPaymentControl.enable();
        this.showCreditCardOptions = false;
        this.formOfPaymentOptions = [
          { label: 'PIX', value: 'pix' },
          { label: 'Cartão de Crédito', value: 'creditCard' },
        ]; // Restaura as opções de pagamento
        this.adjustedExperienceValue = null; // Limpa o valor ajustado
        return;
      }

      this.updatePaymentOptionsAndTotal(useBalance ?? false, selectedExperience);
    });

    // Listener para o campo de forma de pagamento
    this.finalizePaymentformGroup.controls.formOfPaymentControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((selectedPaymentMethod) => {
        this.showCreditCardOptions = selectedPaymentMethod === 'creditCard';
      });

    this.screenWidth = window.innerWidth;

    // Buscar o plano atual do sócio e, em seguida, buscar as experiências relacionadas
    this.memberService.getMemberPlanDashboardData(this.currentUserData.id).subscribe({
      next: (currentPlan: any) => {
        this.currentPlan = currentPlan;

        this.getExperiencesByPlan(this.currentPlan.plan.id);
      },
      error: (e) => {
        console.error('Erro ao buscar o plano atual do sócio:', e);
        this.alertService.showAlert(
          AlertType.WARNING,
          this.replaceTextPipe.transform('Erro ao buscar o plano atual do sócio.')
        );
      },
    });

    const paymentInfo = {
      plan: '',
      frequency: '',
      invoiceRecurrence: true,
      formOfPayment: '',
      creditCard: '',
      numberOfInstallments: '',
    } as PaymentInfoModel;

    this.initializeForm(this.finalizePaymentformGroup, paymentInfo);
  }

  private updatePaymentOptionsAndTotal(useBalance: boolean, selectedExperience: any): void {
    if (useBalance) {
      if (this.memberScore >= selectedExperience.value) {
        this.finalizePaymentformGroup.controls.formOfPaymentControl.disable();
        this.showCreditCardOptions = false;
        this.formOfPaymentOptions = [];
        this.adjustedExperienceValue = 0;
      } else {
        this.adjustedExperienceValue = selectedExperience.value - this.memberScore;
        this.finalizePaymentformGroup.controls.formOfPaymentControl.enable();
        this.showCreditCardOptions = false;
        this.formOfPaymentOptions = [
          { label: 'PIX', value: 'pix' },
          { label: 'Cartão de Crédito', value: 'creditCard' },
        ];
      }
    } else {
      this.finalizePaymentformGroup.controls.formOfPaymentControl.enable();
      this.showCreditCardOptions = false;
      this.formOfPaymentOptions = [
        { label: 'PIX', value: 'pix' },
        { label: 'Cartão de Crédito', value: 'creditCard' },
      ];
      this.adjustedExperienceValue = selectedExperience.value;
    }

    // Atualiza o resumo do saldo e taxa
    this.calculateBalanceSummary(useBalance, selectedExperience);
    this.updateFeeValueDisplay(selectedExperience);
  }

  private updateFeeValueDisplay(selectedExperience: any): void {
    if (!this.useBalanceControl.value && selectedExperience?.feeValue !== null) {
    }
  }

  private calculateBalanceSummary(useBalance: boolean, selectedExperience: any): void {
    if (useBalance) {
      // Saldo utilizado será o menor valor entre o saldo disponível e o valor da experiência
      this.balanceUsed = Math.min(this.memberScore, selectedExperience.value);

      // Saldo restante será o saldo atual menos o saldo utilizado
      this.remainingBalance = this.memberScore - this.balanceUsed;
    } else {
      this.balanceUsed = 0;
      this.remainingBalance = this.memberScore;
    }
  }

  getExperiencesByPlan(planId: any): void {
    this.experienceService.getExperiencesByPlan(planId).subscribe({
      next: (experiences: any[]) => {
        this.experiences = this.setValuesExperiencesFiltered(experiences);
        this.experienceOptions = [
          {
            code: '0',
            name: 'Selecione uma experiência',
          } as SelectModel,
          ...this.experiences.map((experience: any) => {
            return {
              code: experience.id,
              name: experience.title,
            } as SelectModel;
          }),
        ];
      },
      error: (e) => {
        console.error('Erro ao buscar experiências:', e);
        this.alertService.showAlert(AlertType.WARNING, 'Erro ao buscar experiências.');
      },
    });
  }

  addScriptMercadoPago() {
    const script = document.createElement('script');
    script.src = 'https://www.mercadopago.com/v2/security.js';
    script.setAttribute('view', 'checkout');
    script.setAttribute('output', 'deviceId');
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      this.deviceId =
        (window as any).deviceId || (window as any).MP_DEVICE_SESSION_ID;
    };
  }


  updateValueOfPayment() {
    this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue(null);
    this.showCreditCardOptions = false;
    this.paymentSummary = {};
  }

  onExperienceChange(): void {
    const selectedExperienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;

    if (selectedExperienceId && selectedExperienceId !== '0') {
      const selectedExperience = this.experiences.find((experience) => experience.id === selectedExperienceId);


      if (selectedExperience) {
        this.selectedExperience = selectedExperience;

        // Atualiza as opções de parcelas com base na experiência selecionada
        this.updateInstallmentsOptions(selectedExperience);

        // Verifica se a experiência é gratuita
        if (selectedExperience.value === 0) {
          this.useBalanceControl.setValue(true);
          this.useBalanceControl.disable();
          this.finalizePaymentformGroup.controls.formOfPaymentControl.disable();
          this.showCreditCardOptions = false;
          this.formOfPaymentOptions = [];
        } else {
          this.useBalanceControl.enable(); // Habilita o campo "Utilizar saldo" para experiências pagas
          const useBalance = this.useBalanceControl.value;

          // Atualiza as opções de pagamento e o total ajustado com base no saldo e na experiência selecionada
          this.updatePaymentOptionsAndTotal(useBalance ?? false, selectedExperience);

          // Limpa o campo de forma de pagamento ao selecionar uma nova experiência
          this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue(null);
        }
      }
    } else {
      // Limpa as opções de forma de pagamento se nenhuma experiência for selecionada
      this.selectedExperience = null;
      this.formOfPaymentOptions = [];
      this.finalizePaymentformGroup.controls.formOfPaymentControl.enable();
      this.showCreditCardOptions = false;

      // Limpa as opções de parcelas
      this.updateInstallmentsOptions(null);
    }
  }

  getSummaryInfo(dontClean = false): void {
    if (this.experienceItem && this.experienceItem[0]?.amount == 0) {
      this.paymentSummary = {
        id: this.experienceItem[0].payments.filter(
          (payment: any) =>
            payment.paymentMethodType.id === PaymentTypeId.GRATUITO
        )[0].id,
        amount: 0,
        plan: this.experienceItem[0].id,
        planName: this.experienceItem[0]?.planName,
        qtyDependents: 0,
        paymentMethodType: {
          id: PaymentTypeId.GRATUITO,
          name: 'Gratuito',
        },
        period: {
          id: PaymentFrequencyId.MENSAL,
          description: 'MENSAL',
        },

        enableItems: [],
      };
    } else {
      if (
        !this.finalizePaymentformGroup.get('formOfPaymentControl')?.value ||
        !this.finalizePaymentformGroup.get('experienceControl')?.value ||
        !this.finalizePaymentformGroup.get('frequencyControl')?.value
      ) {
        return;
      }

      if (this.experienceItem[0].payments) {
        this.paymentMethodType = this.experienceItem[0]?.payments.filter(
          (payment: any) =>
            payment.paymentMethodType.id ===
            this.finalizePaymentformGroup.get('formOfPaymentControl')?.value
        );
      } else {
        this.paymentMethodType = this.experienceItem?.filter(
          (payment: any) =>
            payment.paymentMethodType.id ===
            this.finalizePaymentformGroup.get('formOfPaymentControl')?.value
        );
      }

      if (this.paymentMethodType.length > 1) {
        this.paymentMethodType = this.paymentMethodType.filter(
          (payment: any) =>
            payment.period.id ===
            this.finalizePaymentformGroup.get('frequencyControl')?.value
        );
      }

      if (this.paymentMethodType.length > 1) {
        this.paymentSummary = this.paymentMethodType.reduce(
          (prev: any, current: any) => {
            return prev.qtdInstallments < current.qtdInstallments
              ? prev
              : current;
          }
        );
      }
    }
  }

  private updateInstallmentsOptions(selectedExperience: any): void {

    if (!selectedExperience) {
      this.numberOfInstallmentsOptions = [];
      return;
    }

    const maxInstallments = selectedExperience.installments || 1;

    if (maxInstallments <= 1) {
      this.numberOfInstallmentsOptions = [
        { code: '1', name: '1 parcela' },
      ];
    } else {
      this.numberOfInstallmentsOptions = Array.from({ length: maxInstallments }, (_, i) => ({
        code: (i + 1).toString(),
        name: `${i + 1} parcela${i + 1 > 1 ? 's' : ''}`,
      }));
    }


    // Atualiza o valor do campo de número de parcelas para o primeiro valor disponível
    const firstInstallmentOption = this.numberOfInstallmentsOptions[0]?.code || '1';
    console.log('Definindo valor padrão para o campo de parcelas:', firstInstallmentOption);
    this.creditCardformGroup.get('numberOfInstallmentsControl')?.setValue(firstInstallmentOption);
  }



  updateSummary(experienceId: string | null): void {
    if (!experienceId || experienceId === '0') {
      this.selectedExperience = null;
      return;
    }

    const selectedExperience = this.experiences.find((experience) => experience.id === experienceId);

    if (selectedExperience) {
      this.selectedExperience = {
        name: selectedExperience.name,
        description: selectedExperience.description,
        value: selectedExperience.value,
      };

      console.log('Sumário atualizado com a experiência selecionada:', this.selectedExperience);
    } else {
      console.warn('Experiência selecionada não encontrada.');
      this.selectedExperience = null;
    }
  }

  private rescueWithPoints(): void {
    const selectedExperienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;
    const selectedExperience = this.experiences.find((experience) => experience.id === selectedExperienceId);

    if (!selectedExperience) {
      this.alertService.showAlert(AlertType.WARNING, 'Selecione uma Experiência.');
      return;
    }

    if (this.memberScore < selectedExperience.requiredPoints) {
      this.alertService.showAlert(AlertType.WARNING, 'Saldo insuficiente para essa experiência.');
      return;
    }

    const rescuePayload = {
      memberId: this.currentUserData.id,
      experienceId: selectedExperience.id,
      points: selectedExperience.value,
    };

    console

    this.experienceService.rescueExperience(rescuePayload).subscribe({
      next: () => {
        this.alertService.showAlert(AlertType.SUCCESS, 'Experiência resgatada com sucesso!');
        this.router.navigate(['/resgates'], { state: { rescue: selectedExperience } });
      },
      error: (err) => {
        console.error('Erro ao resgatar experiência:', err);
        this.alertService.showAlert(AlertType.DANGER, 'Erro ao resgatar experiência.');
      },
    });
  }



  save(): void {
    const selectedExperienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;
    const selectedExperience = this.experiences.find((experience) => experience.id === selectedExperienceId);

    if (!selectedExperience) {
      this.alertService.showAlert(AlertType.WARNING, 'Selecione uma Experiência.');
      return;
    }

    const useBalance = this.useBalanceControl.value;

    if (selectedExperience.value === 0) {
      this.useBalanceControl.setValue(true);
      this.rescueWithPoints();
      return;
    }

    if (useBalance && this.memberScore >= selectedExperience.value) {
      this.rescueWithPoints();
    } else {
      let paymentPayload: PaymentExperiencePayload;
      const selectedPaymentMethod = this.finalizePaymentformGroup.get('formOfPaymentControl')?.value as string;

      console.log('Método de pagamento selecionado:', selectedPaymentMethod);

      const paymentMethodId = this.getPaymentMethodId(selectedPaymentMethod.toUpperCase());

      if (!paymentMethodId) {
        this.alertService.showAlert(AlertType.WARNING, 'Método de pagamento inválido.');
        return;
      }

      // Calcula a taxa com base no tipo (valor fixo ou porcentagem)
      const fee = selectedExperience.isFeePercentage
        ? (selectedExperience.value * (selectedExperience.feeValue || 0)) / 100
        : (selectedExperience.feeValue || 0);

      // Inclui a taxa no cálculo do valor ajustado
      const adjustedAmount = useBalance
        ? Math.max(0, selectedExperience.value - this.memberScore) + (selectedExperience.value > 0 ? fee : 0)
        : selectedExperience.value + (selectedExperience.value > 0 ? fee : 0);

      paymentPayload = {
        cardCvv: this.creditCardformGroup.get('cvvControl')?.value || '',
        cardExpirationDate:
          this.creditCardformGroup
            .get('expirationDateControl')
            ?.value?.replace(/\/(\d{2})$/, '/20$1') || '',
        cardHolderName: this.creditCardformGroup.get('cardNameControl')?.value || '',
        cardNumber: this.creditCardformGroup.get('cardNumberControl')?.value || '',
        cpf: this.creditCardformGroup.get('CPFControl')?.value || '',
        memberId: this.currentUserData.id,
        memberPlanId: this.currentPlan?.id || '',
        paymentMethodId: paymentMethodId,
        amount: adjustedAmount,
        experienceId: selectedExperience.id,
        installments: parseInt(this.creditCardformGroup.get('numberOfInstallmentsControl')?.value || '1'),
      };

      this.postPaidExperience(
        paymentPayload as PaymentExperiencePayload,
        selectedPaymentMethod as PaymentType
      );
    }
  }

  private getPaymentMethodId(paymentMethod: string): string | null {
    console.log('Método de pagamento recebido:', paymentMethod);
    switch (paymentMethod.toUpperCase()) {
      case 'PIX':
        return PaymentTypeId.PIX;
      case 'CREDITCARD':
      case PaymentType.CREDITO.toUpperCase():
        return PaymentTypeId.CREDITO;
      default:
        return null;
    }
  }


  postPaidExperience(paymentPayload: PaymentExperiencePayload, paymentType: PaymentType): void {
    const experienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;

    if (!experienceId) {
      this.alertService.showAlert(AlertType.WARNING, 'ID da experiência inválido.');
      return;
    }

    const chargerPayload: PaymentExperiencePayload = {
      cardNumber: paymentPayload.cardNumber,
      cardHolderName: paymentPayload.cardHolderName,
      cardCvv: paymentPayload.cardCvv,
      cardExpirationDate: paymentPayload.cardExpirationDate,
      memberId: this.currentUserData.id,
      paymentMethodId: paymentPayload.paymentMethodId,
      cpf: paymentPayload.cpf,
      amount: paymentPayload.amount,
      memberPlanId: this.currentPlan?.id || '',
      experienceId: experienceId,
      installments: paymentPayload.installments,
    };

    this.paymentDataService.createExperience(chargerPayload).subscribe(
      (data: any) => {
        this.blockSubmit();
        if (!data.status) {
          // Cenário de sucesso: status não está presente
          const selectedExperience = this.experiences.find((exp) => exp.id === experienceId);
          this.alertService.showAlert(AlertType.SUCCESS, 'Experiência resgatada com sucesso!');
          this.router.navigate(['/resgates'], { state: { rescue: selectedExperience } });
        } else if (data.status === 'waiting_payment') {
          // Pagamento via PIX aguardando confirmação
          this.paymentModalData = {
            invoiceNumer: data.orderId,
            invoiceCode: data.qrCodeData,
            invoiceCodeImg: data.qrCodeImageUrl,
          };
          this.paymentType = PaymentType.PIX;
          this.modalService.open(this.modalId);

          // Inicia a verificação do pagamento via PIX
          this.checkPixPayment(data.orderId);
        } else {
          // Erro no pagamento
          this.alertService.showAlert(AlertType.DANGER, data.message || 'Erro ao processar o pagamento.');
        }
      },
      (error) => {
        console.error('Erro ao processar o pagamento:', error);
        const errorMessage = error?.error?.message || 'Erro ao processar o pagamento.';
        this.alertService.showAlert(AlertType.DANGER, errorMessage);

        this.blockSubmit();
      }
    );
  }

  blockSubmit() {
    this.submitCount = 10;
    if (this.submitCount > 0) {
      const interval = setInterval(() => {
        this.submitCount--;
        if (this.submitCount === 0) {
          clearInterval(interval);
        }
      }, 1000);
    }
  }


  checkPixPayment(orderId: any): void {
    this.paymentDataService.getPaymentOrder(orderId).subscribe((data) => {
      if (data.status !== 'paid') {
        if (this.canChekPix) {
          setTimeout(() => {
            this.checkPixPayment(orderId);
          }, 3000);
        }
      } else {
        const experienceId = this.finalizePaymentformGroup.get('experienceControl')?.value;

        if (!experienceId) {
          this.alertService.showAlert(AlertType.WARNING, 'ID da experiência inválido.');
          return;
        }

        const selectedExperience = this.experiences.find((exp) => exp.id === experienceId);

        if (selectedExperience) {
          this.alertService.showAlert(AlertType.SUCCESS, 'Experiência resgatada com sucesso!');
          this.router.navigate(['/resgates'], { state: { rescue: selectedExperience } });
        } else {
          console.warn('Experiência não encontrada após confirmação de pagamento.');
        }

        this.modalService.close(this.modalId);
      }
    });
  }

  private initializeForm(formGroup: FormGroup, paymentInfo: PaymentInfoModel): void {
    if (Object.keys(paymentInfo).length > 0) {
      formGroup.get('experienceControl')?.setValue(paymentInfo?.plan);
      formGroup
        .get('invoiceRecurrenceControl')
        ?.setValue(paymentInfo?.invoiceRecurrence);
      formGroup
        .get('formOfPaymentControl')
        ?.setValue(paymentInfo?.formOfPayment);
      formGroup.get('dependentControl')?.setValue(paymentInfo?.dependents);
      if (
        paymentInfo?.formOfPayment === PaymentType.CREDITO ||
        paymentInfo?.formOfPayment === PaymentType.CREDITO_ABREVIADO ||
        paymentInfo?.formOfPayment === PaymentType.CREDITO_RECORRENCIA
      ) {
        formGroup.get('creditCardControl')?.setValue(paymentInfo?.creditCard);
        if (paymentInfo?.formOfPayment === PaymentType.CREDITO_RECORRENCIA) {
          formGroup.get('numberOfInstallmentsControl')?.setValue('1');
        } else {
          formGroup
            .get('numberOfInstallmentsControl')
            ?.setValue(paymentInfo?.numberOfInstallments);
        }
        this.setCreditFieldRequired();
      }
    }
  }

  private setCreditFieldRequired(): void {
    this.creditCardformGroup.controls.cardNumberControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.expirationDateControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.cvvControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.cardNameControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.CPFControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.numberOfInstallmentsControl.setValidators(
      Validators.required
    );
    this.creditCardformGroup.controls.cardNumberControl.updateValueAndValidity();
    this.creditCardformGroup.controls.expirationDateControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cvvControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cardNameControl.updateValueAndValidity();
    this.creditCardformGroup.controls.CPFControl.updateValueAndValidity();
    this.creditCardformGroup.controls.numberOfInstallmentsControl.updateValueAndValidity();
  }



  getPaymentFormLabel(formOfPaymentId: string): string {
    return (
      this.formOfPaymentOptions.find(
        (payment: any) => payment.value === formOfPaymentId
      )?.label || ''
    );
  }

  setValuesExperiencesFiltered(experiences: any[]): any[] {
    const transformedExperiences: any[] = [];
    experiences.forEach((item: any) => {
      const experience = {
        rescue: true,
        topIcon: true,
        title: item.name,
        content: item.description,
        image: this.commonService.getImageStr(item.document.id),
        valid: item.isActive,
        point: item.requiredPoints,
        value: item.value,
        feeValue: item.feeValue,
        isFeePercentage: item.isFeePercentage,
        inactiveItem: false,
        memberId: this.currentUserData.id,
        inactiveButton: false,
        id: item.id,
        installments: item.installments,
      };
      transformedExperiences.push(experience);
    });
    return transformedExperiences;
  }


  onModalConfirm(): void { }

  ngOnDestroy(): void {

    this._destroy$.next();
    this._destroy$.complete();
    this.canChekPix = false;
  }

  back() {
    this.location.back();
  }
}


